import script from "./NameStreamgraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./NameStreamgraph.vue?vue&type=script&setup=true&lang=ts"

import "./NameStreamgraph.vue?vue&type=style&index=0&id=13c45a5e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c45a5e"]])

export default __exports__